import React from 'react'
import './styles.scss'

export default function CircularProgress(props) {
  return <progress className="pure-material-progress-circular" {...props} />
}
